/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TableInTableList from './TableInTableList';

/**
 * The GetProjectResponse model module.
 * @module model/GetProjectResponse
 * @version 2.8.0
 */
class GetProjectResponse {
    /**
     * Constructs a new <code>GetProjectResponse</code>.
     * @alias module:model/GetProjectResponse
     * @param id {String} 
     * @param name {String} 
     * @param userId {String} 
     * @param collections {Array.<String>} 
     * @param tables {Array.<module:model/TableInTableList>} 
     * @param creationDate {String} 
     */
    constructor(id, name, userId, collections, tables, creationDate) { 
        
        GetProjectResponse.initialize(this, id, name, userId, collections, tables, creationDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, userId, collections, tables, creationDate) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['userId'] = userId;
        obj['collections'] = collections;
        obj['tables'] = tables;
        obj['creationDate'] = creationDate;
    }

    /**
     * Constructs a <code>GetProjectResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetProjectResponse} obj Optional instance to populate.
     * @return {module:model/GetProjectResponse} The populated <code>GetProjectResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetProjectResponse();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('collections')) {
                obj['collections'] = ApiClient.convertToType(data['collections'], ['String']);
            }
            if (data.hasOwnProperty('tables')) {
                obj['tables'] = ApiClient.convertToType(data['tables'], [TableInTableList]);
            }
            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
GetProjectResponse.prototype['id'] = undefined;

/**
 * @member {String} name
 */
GetProjectResponse.prototype['name'] = undefined;

/**
 * @member {String} userId
 */
GetProjectResponse.prototype['userId'] = undefined;

/**
 * @member {Array.<String>} collections
 */
GetProjectResponse.prototype['collections'] = undefined;

/**
 * @member {Array.<module:model/TableInTableList>} tables
 */
GetProjectResponse.prototype['tables'] = undefined;

/**
 * @member {String} creationDate
 */
GetProjectResponse.prototype['creationDate'] = undefined;






export default GetProjectResponse;

